import fetch from '@/utils/fetch';

// 新增类型
export function addTrainType(args) {
    let params = new URLSearchParams();
    params.append('dictionaryCode', args.dictionaryCode);
    params.append('dictionaryName', args.dictionaryName);
    params.append('logoUrl', args.logoUrl);
    params.append('manUserJson', args.manUserJson);
    params.append('name', args.name);
    params.append('orderNo', args.orderNo);
    params.append('remarkContent', args.remarkContent);

    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/throughTrain/addTrainType',
        method: 'post',
        data: JSON.stringify(args)
    });

}

// 根据学校id查询类型列表

export function getTrainTypeListBySchoolId() {

    return fetch({
        url: 'structure/throughTrain/getTrainTypeListBySchoolId',
        method: 'get'
    });
}

// 删除类型
export function delTrainType(args) {
    let params = new URLSearchParams();
    params.append('typeId', args.typeId);

    return fetch({
        url: 'structure/throughTrain/delTrainType',
        method: 'get',
        params
    });
}

// 修改类型
export function updateTrainType(args) {
    let params = new URLSearchParams();
    params.append('id', args.id);
    params.append('logoUrl', args.logoUrl);
    params.append('manUserJson', args.manUserJson);
    params.append('name', args.name);
    params.append('orderNo', args.orderNo);
    params.append('remarkContent', args.remarkContent);

    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/throughTrain/updateTrainType',
        method: 'post',
        data: JSON.stringify(args)
    });
}

// 根据id查询类型
export function getTrainTypeById(args) {
    let params = new URLSearchParams();
    params.append('typeId', args.typeId);

    return fetch({
        url: 'structure/throughTrain/getTrainTypeById',
        method: 'get',
        params
    });
}

// 更改类型状态

export function updateTrainTypeState(args) {
    let params = new URLSearchParams();
    params.append('typeId', args.typeId);
    params.append('state', args.state);

    return fetch({
        url: 'structure/throughTrain/updateTrainTypeState',
        method: 'get',
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/setting/setting.js